<template>
  <div class="diag-marker">
    <div class="debug-content" v-if="hover">
      <pre>{{ debug }}</pre>
    </div>
    <q-icon name="las la-atom" @click="hover = !hover"></q-icon>
  </div>
</template>

<style lang="scss">
div.dash div.widget  .diag-marker {

  .q-icon {
    position: absolute;
    top: -15px;
    right: -15px;
    width: 25px;
    height: 25px;
    font-size: 1.5em;
  }

  .debug-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    font-size: 1em;
    background-color: black;
    opacity: 0.7;
    color: white;
    padding: 4px;
    z-index: 2000;
    overflow-y: scroll;

  }
}
</style>

<script>
export default {
  name: 'DiagMarker',
  props: ['l'],
  data () {
    return {
      hover: false
    }
  },
  computed: {
    debug () {
      var obj = this.$parent
      if (this.l && this.l > 0) {
        obj = this.$parent.$parent
      }

      var debug = {}
      Object.getOwnPropertyNames(obj).forEach(key => {
        if (!key.startsWith('$') && !key.startsWith('_') && !(typeof obj[key] === 'function')) {
          debug[key] = obj[key]
        }
      })

      var output = JSON.stringify(debug, null, 3)
      console.log(output)
      return output
    }
  }
}
</script>
